function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M10 0c5.523 0 10 4.477 10 10-.007 5.52-4.48 9.993-10 10-5.523 0-10-4.477-10-10S4.477 0 10 0zm-.001 1.326a8.674 8.674 0 10.314.006l-.314-.006zM10 7.059c.325 0 .588.263.588.588v7.059a.588.588 0 01-1.176 0V7.647c0-.325.263-.588.588-.588zm0-2.353a.588.588 0 110 1.176.588.588 0 010-1.176z",
  fill: "#FFF",
  fillRule: "evenodd"
});
function SvgInfoToast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default SvgInfoToast;